import { Component } from '@angular/core';

@Component({
  selector: 'pc-circle-group-1',
  standalone: true,
  imports: [],
  templateUrl: './circle-group-1.component.html',
  styleUrl: './circle-group-1.component.scss'
})
export class CircleGroup1Component {

}
